import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import './Pages.css';

interface Feature { icon: import('../components/Icon').IconName; title: string; desc: string; }
const features: Feature[] = [
  { icon: 'sos', title: 'One-Touch SOS', desc: 'A dedicated physical button starts the emergency transmission: no application, no contact search, no dependency on mobile service.' },
  { icon: 'broadcast', title: 'Network-Independent Trigger', desc: 'The SOS device does not attempt to make a conventional call. It transmits directly through the LoRa layer.' },
  { icon: 'lora', title: 'LoRa Communication', desc: 'Long-range wireless sends essential data (device identity, status, and location) to a nearby gateway.' },
  { icon: 'pin', title: 'Location-Aware Alerts', desc: 'GPS-equipped devices include location with every alert. Responders know exactly where help is needed.' },
  { icon: 'shield', title: 'Real-Time Dashboard', desc: 'A centralized web interface displays emergency incidents with map visualization and status tracking.' },
  { icon: 'map', title: 'Map-Based Monitoring', desc: 'Geographic display lets authorities understand where assistance is required at a glance.' },
  { icon: 'layers', title: 'Ward-Based Filtering', desc: 'Filter and manage alerts according to administrative wards or geographic regions.' },
  { icon: 'alert', title: 'Alert Acknowledgement', desc: 'Responders can visibly recognize an alert so incidents are not overlooked.' },
  { icon: 'users', title: 'Responder Assignment', desc: 'Alerts are assigned to specific responders or teams for clear accountability.' },
  { icon: 'clock', title: 'Status Tracking', desc: 'Follow progress from initial alert through acknowledgment, assignment, progress, and resolution.' },
  { icon: 'zap', title: 'Low-Cost Deployment', desc: 'Affordable IoT components and open technologies make deployment realistic in resource-constrained regions.' },
  { icon: 'cpu', title: 'Expandable Sensors', desc: 'The same LoRa infrastructure can support environmental sensors, flood monitors, and weather stations.' },
];

export default function Features() {
  return (
    <div className="page">
      <section className="page-hero page-hero--dark">
        <div className="container">
          <span className="eyebrow">Key Features</span>
          <h1>Every feature is designed for the reality of an emergency.</h1>
          <p className="lede">Simple interaction. Independent transmission. Actionable response.</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="features-grid">
            {features.map((f, i) => (
              <div key={f.title} className="feature-card reveal" style={{ animationDelay: `${i * 60}ms` }}>
                <div className="feature-card__icon"><Icon name={f.icon} size={22} /></div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
